type Named = { email: string; firstName: string | null; lastName: string | null };

/** "Paul Westerdale", or the email when Kinde gave no name. */
export function userName({ email, firstName, lastName }: Named): string {
  return [firstName, lastName].filter(Boolean).join(" ") || email;
}
